import type { DeviceFeatures } from "types/features.types"

import {
  motionPlotDef,
  motionIntensityPlotDef,
  conductorTemperaturePlotDef,
  lastConductorTemperaturePlotDef,
  bendingAmplitudePlotDef,
  maxBendingAmplitudePlotDef,
  dataPercentageAboveLimitPlotDef,
  cumulativeFatiguePlotDef,
  lastCumulativeFatiguePlotDef,
  iceAccretionDetectionPlotDef,
  lastIceAccretionDetectionPlotDef,
  transverseWindSpeedPlotDef,
  lastWindSpeedPlotDef,
  standardSagPlotDef,
  dualSagPlotDef,
  lastMaxSagMultiDef,
  lastLowestPointSagMultiDef,
  lastMidpointSagMultiDef,
  standardConductorTensionPlotDef,
  dualConductorTensionPlotDef,
  lastHorizontalTensionMultiDef,
  lastTensionAtLowerSupportMultiDef,
  lastTensionAtUpperSupportMultiDef,
  currentPlotDef,
  lastCurrentPlotDef,
  batteryLevelPlotDef,
  batteryStatusPlotDef,
  signalStatusPlotDef,
  averageInclinationPlotDef,
  wStationTemperaturePlotDef,
  lastWStationTemperaturePlotDef,
  wStationHumidityPlotDef,
  lastWStationHumidityPlotDef,
  wStationPressurePlotDef,
  lastWStationPressurePlotDef,
  wStationPrecipitationIntensityPlotDef,
  lastWStationPrecipitationIntensityPlotDef,
  wStationSolarIrradiancePlotDef,
  lastWStationSolarIrradiancePlotDef,
  wStationWindDirectionPlotDef,
  lastWStationWindDirectionPlotDef,
  wStationWindSpeedPlotDef,
  lastWStationWindSpeedPlotDef,
  wServiceAmbientWindSpeedPlotDef,
  lastWServiceAmbientWindSpeedPlotDef,
  wServiceAmbientWindGustPlotDef,
  lastWServiceAmbientWindGustPlotDef,
  wServiceAmbientWindDirectionPlotDef,
  lastWServiceAmbientWindDirectionPlotDef,
  wServiceAmbientTemperaturePlotDef,
  lastWServiceAmbientTemperaturePlotDef,
  wServiceAmbientRelativeHumidityPlotDef,
  lastWServiceAmbientRelativeHumidityPlotDef,
  wServiceAmbientPrecipitationPlotDef,
  lastWServiceAmbientPrecipitationPlotDef,
} from "./defs"

export const getSpanTabPlotDefs = (features: Partial<DeviceFeatures>) => [
  conductorTemperaturePlotDef,
  lastConductorTemperaturePlotDef,
  motionPlotDef,
  motionIntensityPlotDef,
  bendingAmplitudePlotDef,
  maxBendingAmplitudePlotDef,
  dataPercentageAboveLimitPlotDef,
  cumulativeFatiguePlotDef,
  lastCumulativeFatiguePlotDef,
  iceAccretionDetectionPlotDef,
  lastIceAccretionDetectionPlotDef,
  transverseWindSpeedPlotDef,
  lastWindSpeedPlotDef,
  features?.sag?.config === "inclination_and_thermal_model"
    ? dualSagPlotDef
    : standardSagPlotDef,
  lastMaxSagMultiDef,
  lastLowestPointSagMultiDef,
  lastMidpointSagMultiDef,
  features?.sag?.config === "inclination_and_thermal_model"
    ? dualConductorTensionPlotDef
    : standardConductorTensionPlotDef,
  lastHorizontalTensionMultiDef,
  lastTensionAtLowerSupportMultiDef,
  lastTensionAtUpperSupportMultiDef,
  currentPlotDef,
  lastCurrentPlotDef,
]

export const deviceTabPlotDefs = [
  batteryLevelPlotDef,
  batteryStatusPlotDef,
  signalStatusPlotDef,
]

export const getTowerTabPlotDefs = (features: Partial<DeviceFeatures>) => [
  // When tower_health is active the total tilt is shown as a line inside the
  // "Tilts" plot, so the standalone average inclination plot
  // is dropped here to avoid duplication.
  ...(features?.tower_health?.enabled === true ? [] : [averageInclinationPlotDef]),
  motionPlotDef,
  motionIntensityPlotDef,
]

export const wStationAmbientTabPlotDefs = [
  wStationTemperaturePlotDef,
  lastWStationTemperaturePlotDef,
  wStationHumidityPlotDef,
  lastWStationHumidityPlotDef,
  wStationPressurePlotDef,
  lastWStationPressurePlotDef,
  wStationPrecipitationIntensityPlotDef,
  lastWStationPrecipitationIntensityPlotDef,
  wStationSolarIrradiancePlotDef,
  lastWStationSolarIrradiancePlotDef,
  wStationWindDirectionPlotDef,
  lastWStationWindDirectionPlotDef,
  wStationWindSpeedPlotDef,
  lastWStationWindSpeedPlotDef,
]

// Weather-service (geohash) plots for span devices — same metrics as the tower
// weather-service block, keyed by the span device's own location geohash.
export const wServiceAmbientTabPlotDefs = [
  wServiceAmbientWindSpeedPlotDef,
  lastWServiceAmbientWindSpeedPlotDef,
  wServiceAmbientWindGustPlotDef,
  lastWServiceAmbientWindGustPlotDef,
  wServiceAmbientWindDirectionPlotDef,
  lastWServiceAmbientWindDirectionPlotDef,
  wServiceAmbientTemperaturePlotDef,
  lastWServiceAmbientTemperaturePlotDef,
  wServiceAmbientRelativeHumidityPlotDef,
  lastWServiceAmbientRelativeHumidityPlotDef,
  wServiceAmbientPrecipitationPlotDef,
  lastWServiceAmbientPrecipitationPlotDef,
]
